import type { Command } from '../types';

export function createCommand<T = void>(type: string): Command<T> {
  return { type };
}
